var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTilesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "current !important",
    stroke: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.771411 0C0.345592 0 0 0.345592 0 0.771411V6.9427C0 7.36852 0.345592 7.71411 0.771411 7.71411H6.9427C7.36852 7.71411 7.71411 7.36852 7.71411 6.9427V0.771411C7.71411 0.345592 7.36852 0 6.9427 0H0.771411Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.771411 10.2852C0.345592 10.2852 0 10.6307 0 11.0566V17.2279C0 17.6537 0.345592 17.9993 0.771411 17.9993H6.9427C7.36852 17.9993 7.71411 17.6537 7.71411 17.2279V11.0566C7.71411 10.6307 7.36852 10.2852 6.9427 10.2852H0.771411Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0562 10.2852C10.6304 10.2852 10.2848 10.6307 10.2848 11.0566V17.2279C10.2848 17.6537 10.6304 17.9993 11.0562 17.9993H17.2275C17.6533 17.9993 17.9989 17.6537 17.9989 17.2279V11.0566C17.9989 10.6307 17.6533 10.2852 17.2275 10.2852H11.0562Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0562 0C10.6304 0 10.2848 0.345592 10.2848 0.771411V6.9427C10.2848 7.36852 10.6304 7.71411 11.0562 7.71411H17.2275C17.6533 7.71411 17.9989 7.36852 17.9989 6.9427V0.771411C17.9989 0.345592 17.6533 0 17.2275 0H11.0562Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTilesIcon);
export default __webpack_public_path__ + "static/media/tilesIcon.56a2064c19afe0ee071fb06de9727025.svg";
export { ForwardRef as ReactComponent };